import React from 'react';

export type ErrorValidator<T extends { settings?: object }> = (props: T) => string;
export type TouchCalculator<T extends { settings?: object }> = (props: T) => boolean;
export type ComponentSpecs<Props extends { settings?: object }> = {
  name: string;
  component: React.ComponentType<Props>;
  onSubmit?: (settings: Props['settings']) => Promise<Props['settings'] | void> | void;
  initialDataConversion?: (settings: Readonly<Props['settings']>) => Props['settings'];
  meta?: {
    [k in keyof Props['settings']]?: {
      initError: ErrorValidator<Props>;
      initTouched: TouchCalculator<Props>;
    }
  };
};

/**
 * A helper function, used as a workaround to get stronger types when passing specs to createComponentRegistry
 * @param specs
 */
export function componentRegistryEntry<Props>(specs: ComponentSpecs<Props>) {
  return specs;
}
